export const formatBackendDateWithoutTime = (date: string) => date.split(' ')[0] ?? date;
